export * from "/vercel/path0/node_modules/react-device-detect/dist/lib.js"